import { render, staticRenderFns } from "./ApiDataTable.vue?vue&type=template&id=ada370b8"
import script from "./ApiDataTable.vue?vue&type=script&lang=js"
export * from "./ApiDataTable.vue?vue&type=script&lang=js"
import style0 from "./ApiDataTable.vue?vue&type=style&index=0&id=ada370b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports